<template>
	<BaseModal closable :title="titleName" :subTitle="`${releaseYear}`" @dismiss="handleClose">
		<div style="padding: 15px">
			<TitleDetail :entityId @closeTitleDetailModal="handleClose" />
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import TitleDetail from '@/pages/TitleDetail.vue';

import { useSearchTracking } from '@/features/search/tracking';
import { useTrackingStore } from '@/stores/pinia/useTrackingStore';

defineProps<{
	entityId: string;
	titleName: string;
	releaseYear?: string | number;
}>();

const emit = defineEmits(['dismiss']);

const { killSearchSession } = useSearchTracking();
const { setOverridePageState } = useTrackingStore();

function handleClose() {
	killSearchSession();
	emit('dismiss');

	// ensure the modal state is reset
	setOverridePageState(null);
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/typography.scss';

.jw-title-detail-modal {
	width: 100vw !important;
	height: 100vh !important;

	.modal-wrapper {
		width: 100%;
		height: 100vh;
	}
}
</style>
